import { AppState } from 'src/app/core/core.state'
import { ResourceEffects } from 'src/app/shared/resource-effects'

import { Injectable } from '@angular/core'
import { Actions } from '@ngrx/effects'
import { Store } from '@ngrx/store'

import { CompetitionStaff } from './competition-staff'
import { competitionStaffActions } from './competition-staff.actions'
import * as fromCompetitionStaff from './competition-staff.reducer'
import { CompetitionStaffService } from './competition-staff.service'

@Injectable()
export class CompetitionStaffEffects extends ResourceEffects<CompetitionStaff> {
  constructor(
    public actions$: Actions,
    public store: Store<AppState>,
    public competitionStaffService: CompetitionStaffService
  ) {
    super(
      fromCompetitionStaff.FEATURE_NAME,
      competitionStaffService,
      competitionStaffActions,
      actions$
    )
  }
}
